// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602090925/js/" + chunkId + "." + {"44":"446fc6ec","225":"2c62b47f","481":"06cbf249","486":"d37e0d3f","770":"7293ee67"}[chunkId] + ".0.1963733514197903.chunk.js";
};